<span (click)="snackBarRef.dismissWithAction()" class="example-pizza-party" matSnackBarLabel>
    Richiesta archiviata con successo!
</span>